import {CircularProgress} from "@mui/material";
import React from "react";

const GlobalLoader = () => {
  return (
    <div className="global_loader">
      <CircularProgress size={50} thickness={4} />
    </div>
  );
};

export default GlobalLoader;
